import { ReactNode } from 'react';

import { Separator } from 'src/registry/ui/Separator';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';

export interface SidePanelTabItem {
    key: string;
    label: string;
    content: ReactNode;
}

interface SidePanelTabsProps {
    tabs: SidePanelTabItem[];
    defaultActiveKey?: string;
}

const SidePanelTabs = ({ tabs, defaultActiveKey }: SidePanelTabsProps) => {
    return (
        <Tabs defaultValue={defaultActiveKey || tabs[0].key} className="w-full">
            <TabsList className="flex border-b border-gray-200 bg-transparent p-0 rounded-none">
                {tabs.map(({ key, label }) => (
                    <TabsTrigger
                        key={key}
                        value={key}
                        className="data-[state=active]:text-primary-700 data-[state=active]:after:bg-primary-700 relative w-full cursor-pointer rounded-none  font-semibold text-gray-500 no-underline transition-colors after:absolute after:right-0 after:bottom-0 after:left-0 after:h-[2px] after:bg-transparent after:transition-all after:duration-200 hover:bg-transparent hover:text-inherit"
                    >
                        {label}
                    </TabsTrigger>
                ))}
            </TabsList>
            <Separator />
            {tabs.map(({ key, content }) => (
                <TabsContent key={key} value={key}>
                    {content}
                </TabsContent>
            ))}
        </Tabs>
    );
};

export default SidePanelTabs;
